/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelQuoteOrder.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/quote-order";

export class AutogenModelQuoteOrder<RowType extends ModelRow> extends Endpoint<RowType, RowQuoteOrderFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowQuoteOrder extends ModelRow<RowQuoteOrderFields> {
	constructor(values?: Partial<RowQuoteOrderFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowQuoteOrderFields {
	actual_reefer_profile: string;
	agency_id: string;
	agent_payee_id: string;
	all_in_rate: string;
	allow_relay: string;
	app_status_id: string;
	autorate_status: string;
	bill_date: Date;
	bill_distance: number;
	bill_distance_um: string;
	billing_clerk: string;
	billing_empty_distance: number;
	billing_empty_distance_um: string;
	billing_loaded_distance: number;
	billing_loaded_distance_um: string;
	billing_user_id: string;
	blnum: string;
	blnum2: string;
	blnum3: string;
	bol_note: string;
	bol_received: string;
	bol_recv_date: Date;
	booking_no: string;
	booking_number: string;
	brk_qual_profile: string;
	broker_location_id: string;
	brokerage: string;
	brokerage_workflow_id: string;
	cbp_crossing_date: Date;
	cbp_crossing_location_id: string;
	cbp_crossing_reason: string;
	cbsa_crossing_date: Date;
	cbsa_crossing_location_id: string;
	cbsa_crossing_reason: string;
	cc_fuel_revenue: number;
	cc_fuel_revenue_c: string;
	cc_fuel_revenue_d: Date;
	cc_fuel_revenue_n: number;
	cc_fuel_revenue_r: number;
	cc_net_revenue: number;
	cc_net_revenue_c: string;
	cc_net_revenue_d: Date;
	cc_net_revenue_n: number;
	cc_net_revenue_r: number;
	cc_pro_nbr: string;
	cobroker_location_id: string;
	collection_method: string;
	com_setpnt_temp: number;
	com_setpnt_temp_um: string;
	commitment_id: string;
	commodity: string;
	commodity_id: string;
	company_id: string;
	consgne_refno_stop: string;
	"consignee.actual_arrival": Date;
	"consignee.actual_departure": Date;
	"consignee.address": string;
	"consignee.address2": string;
	"consignee.appointment_status_id": string;
	"consignee.appt_contact_name": string;
	"consignee.appt_required": string;
	"consignee.cases": number;
	"consignee.city_id": number;
	"consignee.city_name": string;
	"consignee.company_id": string;
	"consignee.confirmed": string;
	"consignee.contact_email": string;
	"consignee.contact_name": string;
	"consignee.dist_from_prev": number;
	"consignee.dist_from_prev_um": string;
	"consignee.driver_load_unload": string;
	"consignee.edi_code": string;
	"consignee.edi_loc_code": string;
	"consignee.eta": Date;
	"consignee.eta_distance": number;
	"consignee.eta_late": string;
	"consignee.eta_oor": string;
	"consignee.google_place_id": string;
	"consignee.grouped_id": number;
	"consignee.hub": number;
	"consignee.ic_stop_id": string;
	"consignee.id": string;
	"consignee.inbound_status": string;
	"consignee.late_eta_colorcode": string;
	"consignee.late_route_status": string;
	"consignee.latitude": number;
	"consignee.lease_number": string;
	"consignee.location_id": string;
	"consignee.location_name": string;
	"consignee.longitude": number;
	"consignee.manifest_fgp_uid": number;
	"consignee.manifest_reg_uid": number;
	"consignee.move_dist_from_preassign": number;
	"consignee.move_dist_from_preassign_um": string;
	"consignee.move_dist_from_previous": number;
	"consignee.move_dist_from_previous_um": string;
	"consignee.movement_id": string;
	"consignee.movement_sequence": number;
	"consignee.operational_status": string;
	"consignee.order_id": string;
	"consignee.order_sequence": number;
	"consignee.orig_sched_early": Date;
	"consignee.orig_sched_late": Date;
	"consignee.pallets_dropped": number;
	"consignee.pallets_picked_up": number;
	"consignee.payment_code_reviewed": string;
	"consignee.phone": string;
	"consignee.planned_arrival_time": Date;
	"consignee.ponum": string;
	"consignee.prior_uncleared_stops": string;
	"consignee.projected_arrival": Date;
	"consignee.pu_override_arrive_early": Date;
	"consignee.pu_override_arrive_late": Date;
	"consignee.rate_dist_from_previous": number;
	"consignee.rate_dist_from_previous_um": string;
	"consignee.refno": string;
	"consignee.requested_service": string;
	"consignee.sched_arrive_early": Date;
	"consignee.sched_arrive_late": Date;
	"consignee.seal": string;
	"consignee.service_date": Date;
	"consignee.showas_address": string;
	"consignee.showas_address2": string;
	"consignee.showas_city_id": number;
	"consignee.showas_city_name": string;
	"consignee.showas_location_id": string;
	"consignee.showas_location_name": string;
	"consignee.showas_state": string;
	"consignee.showas_zip_code": string;
	"consignee.signed_for_name": string;
	"consignee.state": string;
	"consignee.status": string;
	"consignee.stop_type": string;
	"consignee.tank_operator": string;
	"consignee.trimble_place_id": string;
	"consignee.txl_uid": number;
	"consignee.volume": number;
	"consignee.volume_um": string;
	"consignee.weight": number;
	"consignee.weight_um": string;
	"consignee.zip_code": string;
	"consignee.zone_id": string;
	consignee_refno: string;
	consignee_stop_id: string;
	container: string;
	container_planned: string;
	container_type_id: string;
	controlling_carrier_code: string;
	copy_from_company: string;
	copy_from_order_id: string;
	copy_to_company: string;
	copy_to_order_id: string;
	"ctrl_party.address1": string;
	"ctrl_party.address2": string;
	"ctrl_party.appt_required": string;
	"ctrl_party.assigned_to": string;
	"ctrl_party.bseg": string;
	"ctrl_party.category": string;
	"ctrl_party.cbsa_port_id": string;
	"ctrl_party.chassis_owner": string;
	"ctrl_party.chassis_pool": string;
	"ctrl_party.city_id": number;
	"ctrl_party.city_name": string;
	"ctrl_party.class_rqmt": string;
	"ctrl_party.comments": string;
	"ctrl_party.company_id": string;
	"ctrl_party.container_pool": string;
	"ctrl_party.container_vendor": string;
	"ctrl_party.cust_id": string;
	"ctrl_party.customer_id": string;
	"ctrl_party.days_between_calls": number;
	"ctrl_party.ded_rqmt_type": string;
	"ctrl_party.ded_type": string;
	"ctrl_party.def_commodity_desc": string;
	"ctrl_party.def_commodity_id": string;
	"ctrl_party.delivery_date_option": string;
	"ctrl_party.directions": string;
	"ctrl_party.disable_loc_rating": string;
	"ctrl_party.dl_gen_cost": number;
	"ctrl_party.dl_gen_repower": number;
	"ctrl_party.dl_haz_cost": number;
	"ctrl_party.dl_haz_repower": number;
	"ctrl_party.dl_hvl_cost": number;
	"ctrl_party.dl_hvl_repower": number;
	"ctrl_party.dl_load_time": number;
	"ctrl_party.dl_svc_cost": number;
	"ctrl_party.dl_svc_repower": number;
	"ctrl_party.dl_unload_time": number;
	"ctrl_party.driver_load_id": string;
	"ctrl_party.driver_unload_id": string;
	"ctrl_party.ds_capacity_cost": number;
	"ctrl_party.ds_model_flag": string;
	"ctrl_party.email_address": string;
	"ctrl_party.email_location": string;
	"ctrl_party.extra_handling_time": number;
	"ctrl_party.filer_code": string;
	"ctrl_party.foreign_port": string;
	"ctrl_party.friday_close": Date;
	"ctrl_party.friday_open": Date;
	"ctrl_party.fuel_price_region": string;
	"ctrl_party.google_place_fm_address": string;
	"ctrl_party.google_place_id": string;
	"ctrl_party.google_place_type": string;
	"ctrl_party.id": string;
	"ctrl_party.include_xref_trailers": string;
	"ctrl_party.insur_amt_rqrd": number;
	"ctrl_party.insur_amt_rqrd_c": string;
	"ctrl_party.insur_amt_rqrd_d": Date;
	"ctrl_party.insur_amt_rqrd_n": number;
	"ctrl_party.insur_amt_rqrd_r": number;
	"ctrl_party.is_active": string;
	"ctrl_party.is_consignee": string;
	"ctrl_party.is_customer": string;
	"ctrl_party.is_customs_broker": string;
	"ctrl_party.is_dist_center": string;
	"ctrl_party.is_dl_gen": string;
	"ctrl_party.is_dl_haz": string;
	"ctrl_party.is_dl_hvl": string;
	"ctrl_party.is_dl_svc": string;
	"ctrl_party.is_drop_yard": string;
	"ctrl_party.is_geocoded": string;
	"ctrl_party.is_outside_terminal": string;
	"ctrl_party.is_prospect": string;
	"ctrl_party.is_remote_terminal": string;
	"ctrl_party.is_shipper": string;
	"ctrl_party.is_steamship": string;
	"ctrl_party.is_terminal": string;
	"ctrl_party.is_trailer_pool": string;
	"ctrl_party.is_trailer_wash": string;
	"ctrl_party.is_truckstop": string;
	"ctrl_party.last_used_date": Date;
	"ctrl_party.latitude": number;
	"ctrl_party.layover": string;
	"ctrl_party.lease_number": string;
	"ctrl_party.load_unload_count": number;
	"ctrl_party.load_unload_excl": string;
	"ctrl_party.load_unload_param": string;
	"ctrl_party.loading_instructs": string;
	"ctrl_party.loading_time": number;
	"ctrl_party.longitude": number;
	"ctrl_party.ltl_optimize_time_per_spot": number;
	"ctrl_party.ltl_seg_alloc_code": string;
	"ctrl_party.manual_exchange": string;
	"ctrl_party.max_drvr_complaint": number;
	"ctrl_party.max_pallet_balance": number;
	"ctrl_party.max_payment_code_amt": number;
	"ctrl_party.max_payment_code_amt_c": string;
	"ctrl_party.max_payment_code_amt_d": Date;
	"ctrl_party.max_payment_code_amt_n": number;
	"ctrl_party.max_payment_code_amt_r": number;
	"ctrl_party.model_flag": string;
	"ctrl_party.monday_close": Date;
	"ctrl_party.monday_open": Date;
	"ctrl_party.name": string;
	"ctrl_party.need_clean_trailer": string;
	"ctrl_party.new_field_ms": string;
	"ctrl_party.next_call_date": Date;
	"ctrl_party.no_fuel_radius_inbound": string;
	"ctrl_party.no_fuel_radius_outbound": number;
	"ctrl_party.no_stop_miles": number;
	"ctrl_party.on_duty_not_driving_mins": number;
	"ctrl_party.pallet_balance": number;
	"ctrl_party.pallets_required": string;
	"ctrl_party.payment_api_excluded": string;
	"ctrl_party.pickup_date_option": string;
	"ctrl_party.plc_uid": number;
	"ctrl_party.pnn_city_id": number;
	"ctrl_party.pnn_city_name": string;
	"ctrl_party.pnn_state": string;
	"ctrl_party.pnn_zip_code": string;
	"ctrl_party.port_id": string;
	"ctrl_party.prev_code": string;
	"ctrl_party.primary_agency": string;
	"ctrl_party.radius": number;
	"ctrl_party.regulated": string;
	"ctrl_party.reload_rqmt": string;
	"ctrl_party.reserve_mins": number;
	"ctrl_party.salesperson": string;
	"ctrl_party.saturday_close": Date;
	"ctrl_party.saturday_open": Date;
	"ctrl_party.shuttle_capacity": string;
	"ctrl_party.state": string;
	"ctrl_party.sunday_close": Date;
	"ctrl_party.sunday_open": Date;
	"ctrl_party.swap_cost": number;
	"ctrl_party.tank_operator": string;
	"ctrl_party.team_rqmt": string;
	"ctrl_party.thursday_close": Date;
	"ctrl_party.thursday_open": Date;
	"ctrl_party.trailer_pool_min": number;
	"ctrl_party.trailer_pool_radius": number;
	"ctrl_party.trailer_pool_size": number;
	"ctrl_party.trailer_wash_vend": string;
	"ctrl_party.trans_ticket": string;
	"ctrl_party.trimble_place_id": string;
	"ctrl_party.trip_starter": string;
	"ctrl_party.tuesday_close": Date;
	"ctrl_party.tuesday_open": Date;
	"ctrl_party.tw_seg_code": string;
	"ctrl_party.unload_instructs": string;
	"ctrl_party.unloading_time": number;
	"ctrl_party.website_url": string;
	"ctrl_party.wednesday_close": Date;
	"ctrl_party.wednesday_open": Date;
	"ctrl_party.worthless_field": string;
	"ctrl_party.zip_code": string;
	ctrl_party_id: string;
	cube: number;
	curr_movement_id: string;
	cust_order_no: string;
	customer_contact_name: string;
	customer_email: string;
	customer_fax: string;
	customer_id: string;
	customer_name: string;
	customer_phone: string;
	customer_po_num: string;
	declared_val: number;
	def_move_type: string;
	default_match_id: string;
	dim_height: string;
	dim_length: string;
	dim_surcharge: number;
	dim_surcharge_c: string;
	dim_surcharge_d: Date;
	dim_surcharge_n: number;
	dim_surcharge_r: number;
	dim_width: string;
	dispatch_opt: string;
	dl_team_reqd: string;
	dray_del_date: Date;
	dray_del_pay: number;
	dray_del_pay_c: string;
	dray_del_pay_d: Date;
	dray_del_pay_n: number;
	dray_del_pay_r: number;
	dray_del_payee: string;
	dray_del_xfer_dt: Date;
	dray_pu_date: Date;
	dray_pu_pay: number;
	dray_pu_pay_c: string;
	dray_pu_pay_d: Date;
	dray_pu_pay_n: number;
	dray_pu_pay_r: number;
	dray_pu_payee: string;
	dray_pu_xfer_dt: Date;
	effective_date: Date;
	eir1_no: string;
	eir2_no: string;
	entered_user_id: string;
	equipment_type_id: string;
	equipment_type_options: string;
	est_tolls: number;
	est_tolls_c: string;
	est_tolls_d: Date;
	est_tolls_n: number;
	est_tolls_r: number;
	excise_disable_update: string;
	excise_taxable: string;
	excisetax_total: number;
	excisetax_total_c: string;
	excisetax_total_d: Date;
	excisetax_total_n: number;
	excisetax_total_r: number;
	expiration_date: Date;
	external_invoiceno: string;
	external_refno: string;
	extra_deliveries: number;
	extra_pickups: number;
	fgp_uid: number;
	floor_loaded_freight: string;
	force_assign: string;
	forwd_location_id: string;
	free_days: number;
	freight_charge: number;
	freight_charge_c: string;
	freight_charge_d: Date;
	freight_charge_n: number;
	freight_charge_r: number;
	group_id: string;
	hazmat: string;
	hazmat_code: string;
	high_value: string;
	hold_reason: string;
	ic_company_from: string;
	ic_movement_from: string;
	ic_order_from: string;
	id: string;
	image_is_present: string;
	import_export: string;
	include_split_point: string;
	intelliset: string;
	invoice_recv_date: Date;
	is_auto_tonu: string;
	is_autorate_dist: string;
	is_billed: boolean;
	is_brokerage_ltl: boolean;
	is_container: string;
	is_dedicated: string;
	is_intercompany: string;
	is_local_mile: string;
	is_requested: string;
	is_split: string;
	is_tonu: string;
	jag_carrier_id: string;
	jag_cost_rate_id: number;
	last_location: string;
	ld_issue_code: string;
	ldport_location_id: string;
	linear_feet_avail: number;
	load_date: Date;
	load_issue_code: string;
	load_issue_descr: string;
	loadboard: string;
	lock_miles: string;
	ltl: string;
	markup_flat: number;
	markup_flat_c: string;
	markup_flat_d: Date;
	markup_flat_n: number;
	markup_flat_r: number;
	markup_percent: number;
	master_order_id: string;
	master_sequence: number;
	next_rebill: string;
	notes: string;
	nte_lp_num: string;
	nte_lp_qual: string;
	on_hold: string;
	operational_status: string;
	operations_user: string;
	optimize: string;
	optiset: string;
	order_mode: string;
	order_type_id: string;
	order_value: number;
	order_value_c: string;
	order_value_d: Date;
	order_value_n: number;
	order_value_r: number;
	ordered_by: string;
	ordered_by_id: string;
	ordered_date: Date;
	ordered_method: string;
	orig_dest_rate_id: string;
	otherchargetotal: number;
	otherchargetotal_c: string;
	otherchargetotal_d: Date;
	otherchargetotal_n: number;
	otherchargetotal_r: number;
	override_posting_city_id: number;
	override_rating: string;
	pallets_how_many: number;
	pallets_required: string;
	pay_gross: number;
	pay_gross_c: string;
	pay_gross_d: Date;
	pay_gross_n: number;
	pay_gross_r: number;
	pick_up_no: string;
	pieces: number;
	placard_required: string;
	planning_comment: string;
	pnn_callback: string;
	pnn_comment: string;
	pnn_comment2: string;
	pnn_loadboard_user_id: string;
	pnn_post_type: string;
	pnn_rate: number;
	pnn_rate_type: string;
	pnn_trailer_length: number;
	pnn_trailer_width: number;
	ponum: string;
	port: string;
	port_of_discharge: string;
	preload_trailer_id: string;
	preloaded: string;
	progress_bill: string;
	pta_number: string;
	quote_status: string;
	rate: number;
	rate_currency_type: string;
	rate_id: number;
	rate_min_weight: number;
	rate_min_weight_um: string;
	rate_source: string;
	rate_type: string;
	rate_unit_desc: string;
	rate_units: number;
	ready_to_bill: string;
	recurring_order_id: string;
	reply_transmitted: string;
	requesting_company: string;
	return_temp: number;
	return_temp_um: string;
	return_temp_var: number;
	return_temp_var_um: string;
	revenue_code_id: string;
	revenue_share_method: string;
	rf_entry_code_required: boolean;
	round_trip: string;
	sail_date: Date;
	salesperson_id: string;
	seal_number: string;
	seg_alloc_code: string;
	setpoint_temp: number;
	setpoint_temp_um: string;
	setpoint_var: number;
	setpoint_var_um: string;
	ship_status_to_edi: string;
	shipment_id: string;
	"shipper.actual_arrival": Date;
	"shipper.actual_departure": Date;
	"shipper.address": string;
	"shipper.address2": string;
	"shipper.appointment_status_id": string;
	"shipper.appt_contact_name": string;
	"shipper.appt_required": string;
	"shipper.cases": number;
	"shipper.city_id": number;
	"shipper.city_name": string;
	"shipper.company_id": string;
	"shipper.confirmed": string;
	"shipper.contact_email": string;
	"shipper.contact_name": string;
	"shipper.dist_from_prev": number;
	"shipper.dist_from_prev_um": string;
	"shipper.driver_load_unload": string;
	"shipper.edi_code": string;
	"shipper.edi_loc_code": string;
	"shipper.eta": Date;
	"shipper.eta_distance": number;
	"shipper.eta_late": string;
	"shipper.eta_oor": string;
	"shipper.google_place_id": string;
	"shipper.grouped_id": number;
	"shipper.hub": number;
	"shipper.ic_stop_id": string;
	"shipper.id": string;
	"shipper.inbound_status": string;
	"shipper.late_eta_colorcode": string;
	"shipper.late_route_status": string;
	"shipper.latitude": number;
	"shipper.lease_number": string;
	"shipper.location_id": string;
	"shipper.location_name": string;
	"shipper.longitude": number;
	"shipper.manifest_fgp_uid": number;
	"shipper.manifest_reg_uid": number;
	"shipper.move_dist_from_preassign": number;
	"shipper.move_dist_from_preassign_um": string;
	"shipper.move_dist_from_previous": number;
	"shipper.move_dist_from_previous_um": string;
	"shipper.movement_id": string;
	"shipper.movement_sequence": number;
	"shipper.operational_status": string;
	"shipper.order_id": string;
	"shipper.order_sequence": number;
	"shipper.orig_sched_early": Date;
	"shipper.orig_sched_late": Date;
	"shipper.pallets_dropped": number;
	"shipper.pallets_picked_up": number;
	"shipper.payment_code_reviewed": string;
	"shipper.phone": string;
	"shipper.planned_arrival_time": Date;
	"shipper.ponum": string;
	"shipper.prior_uncleared_stops": string;
	"shipper.projected_arrival": Date;
	"shipper.pu_override_arrive_early": Date;
	"shipper.pu_override_arrive_late": Date;
	"shipper.rate_dist_from_previous": number;
	"shipper.rate_dist_from_previous_um": string;
	"shipper.refno": string;
	"shipper.requested_service": string;
	"shipper.sched_arrive_early": Date;
	"shipper.sched_arrive_late": Date;
	"shipper.seal": string;
	"shipper.service_date": Date;
	"shipper.showas_address": string;
	"shipper.showas_address2": string;
	"shipper.showas_city_id": number;
	"shipper.showas_city_name": string;
	"shipper.showas_location_id": string;
	"shipper.showas_location_name": string;
	"shipper.showas_state": string;
	"shipper.showas_zip_code": string;
	"shipper.signed_for_name": string;
	"shipper.state": string;
	"shipper.status": string;
	"shipper.stop_type": string;
	"shipper.tank_operator": string;
	"shipper.trimble_place_id": string;
	"shipper.txl_uid": number;
	"shipper.volume": number;
	"shipper.volume_um": string;
	"shipper.weight": number;
	"shipper.weight_um": string;
	"shipper.zip_code": string;
	"shipper.zone_id": string;
	shipper_stop_id: string;
	shipstatus2edi_dt: Date;
	show_equipment_type_options: boolean;
	spot_rate: string;
	ss_location_id: string;
	status: string;
	subject_order_number: string;
	subject_order_status: string;
	subject_order_void_date: Date;
	swap: string;
	tarp_type: string;
	teams_required: string;
	temperature_max: number;
	temperature_max_um: string;
	temperature_min: number;
	temperature_min_um: string;
	test: string;
	total_charge: number;
	total_charge_c: string;
	total_charge_d: Date;
	total_charge_n: number;
	total_charge_r: number;
	totalcharge_and_excisetax: number;
	totalcharge_and_excisetax_c: string;
	totalcharge_and_excisetax_d: Date;
	totalcharge_and_excisetax_n: number;
	totalcharge_and_excisetax_r: number;
	tractor_type: string;
	vessel: string;
	vessel_cutoff_date: Date;
	voided_load_transmitted: string;
	voided_load_transmitted_dt: Date;
	weight: number;
	weight_um: string;
	xferred2billing: string;
	xferred2billing_dt: Date;
	days_back: number;
}

